function getNowMouth(){
    let nowMon=new Date().getMonth()+1
    let Lmon;
    if(nowMon<10){
        Lmon="0"+nowMon.toString()
    }else{
        Lmon=nowMon
    }
    let year = new Date().getFullYear()
    let dayNum;
    
    if(nowMon==1||nowMon==3||nowMon==5||nowMon==7||nowMon==8||nowMon==10||nowMon==12){
        dayNum=31
    }else if(nowMon==4||nowMon==6||nowMon==9||nowMon==11){
        dayNum=30
    }else{
        if(year%4){
            dayNum=29
        }else{
            dayNum=28
        }
    }
    let startTime=year+"-"+Lmon+"-"+"01"
    let endTime=year+"-"+Lmon+"-"+dayNum;
    return startTime+","+endTime
}
export {
    getNowMouth
}


// WEBPACK FOOTER //
// ./src/utils/getNowMouth.js